import { Button, Input, List, Modal } from "semantic-ui-react";
import { voidPayment } from "services/payment";

export default function VoidPopup(props: any): JSX.Element {
  const {
    popup,
    setPopup,
    loading,
    setLoading,
    Payment,
    fetchCount,
    setFetchCount,
    selectedRecords,
    setSelectedRecords,
    voidSingle,
  } = props;
  const { deviceId, bookingNumber } = Payment;

  return (
    <Modal
      closeIcon
      style={{ width: "25rem" }}
      onClose={() => setPopup({ ...popup, void: false })}
      open={popup.void}
    >
      <Modal.Header className="text-left">
        <div>Void record</div>
      </Modal.Header>
      <Modal.Content className="text-left">
        <div>
          You are about to void this record with the confirmation no.:
          {voidSingle || selectedRecords.length === 0 ? (
            <b>{Payment?.bookingNumber}</b>
          ) : (
            <List bulleted>
              {selectedRecords.map((item: any) => (
                <List.Item>
                  <b>{item?.bookingNumber}</b>
                </List.Item>
              ))}
            </List>
          )}
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="black"
          onClick={() => setPopup({ ...popup, void: false })}
        >
          Cancel
        </Button>
        <Button
          content="void"
          loading={loading}
          disabled={loading}
          onClick={async () => {
            try {
              // console.log("void?",Payment)
              setLoading((loading: boolean) => true);
              await voidPayment({
                deviceId,
                bookingNumber,
                id: Payment._id,
                selectedRecords,
                voidSingle,
              });
              setLoading((loading: boolean) => false);
              setPopup({ ...popup, void: false });
              setFetchCount(fetchCount + 1);
            } catch (err) {
              setLoading((loading: boolean) => false);
              console.log("void error:", err);
            }
          }}
          color="red"
        />
      </Modal.Actions>
    </Modal>
  );
}
